<template>
<field
	:label="fieldLabel" 
	:col-class="hideLabel ? false : colClass" 
	:params="{type: multi ? 'select-multi' : 'select', options, required}" 
	v-model="localValue"
	:invalid="invalid"
	:loading="jobsLoading"
	:readonly="readonly"
	v-on:close="$emit('close')"
	v-on:searchChange="searchChange"
	v-on:change="valueChange"
	v-on:input="valueChange">
	<small v-if="!readonly">Start typing to find your {{jobType}}</small>
	<div>
		<slot></slot>
	</div>
</field>
</template>
<script type="text/javascript">
import Field from "@/components/Field"

export default {
	name: "JobPicker",
	components: {
		Field
	},
	props: [
		"value",
		"invalid",
		"colClass",
		"readonly",
		"hideLabel",
		"label",
		"required",
		"jobType", //project or service
		"multi",
		"hideArchived",
		"hideCompleted"
	],
	data() {
		return {
			localValue: null,
			jobsLoading: false,
			jobs: []
		}
	},
	watch: {
		value() {
			this.setLocalValue()
			
			if (!this.value || this.value == 0) 
				this.fetchFirstPageJobs()
		}
	},
	computed: {
		apiResource() {
			if (this.jobType == 'project')
				return "Job"
			else
				return "Service"
		},
		fieldLabel() {
			if (this.hideLabel)
				return false

			if (this.label)
				return this.label
			else {
				return this.jobType == 'project' ? "Project" : "Service"
			}
		},
		options() {
			let options = this.optionify(this.jobs.map(job => {
				job.label = ""

				if ("archived" in job && job.archived == 1)
					job.label += "(Archived) "

				job.label += job.job_num// + ": " + job.job_name

				if ("customer_name_cache" in job && job.customer_name_cache)
					job.label += ": " + job.customer_name_cache
				else if ("Customer" in job && job.Customer)
					job.label += ": "+job.Customer.name
				
				if ("job_name" in job && job.job_name)
					job.label += ": "+job.job_name
				if ("address" in job && job.address)
					job.label += ", "+job.address



				return job
			}),"label")

			return options
		}
	},
	methods: {
		setLocalValue() {
			let vm = this
			this.localValue = this.value

			if (this.localValue && !this.jobs.find(job => job.id == this.value)) {
				// not in list, we need to find it, and add it to the options
				this.getJSON(this.apiResource + "/find/" + this.value).then(response => {
					if (response.success) {
						vm.jobs = [response.data]
						vm.$forceUpdate()
					}
				})
			}
		},
		valueChange(value) {
			this.$emit("input",value)
			this.$emit("change",value)

			if (!value) 
				this.fetchFirstPageJobs()
		},
		searchChange(value) {
			if (value) {
				this.debounce("fetchFilteredJobs",value,1000)
				this.jobsLoading = true
			}
		},
		fetchFirstPageJobs() {
			let vm = this

			let params = {
				page: 1,
				fields: ["job_name","job_num","customer_id","customer_name_cache","address","archived"],
				filters: [
					["archived",0]
				],
				orders: [
					["id", "DESC"]
				]
			}

			if (vm.hideCompleted)
				params.filters.push(["completed",null])

			return new Promise((resolve,reject) => {

				vm.getJSON(this.apiResource + "/get",params).then(response => {

					if (response.success)
						vm.jobs = response.data

					resolve(response)
				})

			})
		},
		fetchFilteredJobs(searchTerms) {
			let vm = this

			vm.jobsLoading = true

			let params = {
				filters: [
					["job_name",searchTerms,"and","like"],
					["job_num",searchTerms,"or","like"],
					["customer_name_cache",searchTerms,"or","like"],
					["address",searchTerms,"or","like"]
				],
				fields: ["job_name","job_num","customer_id","customer_name_cache","address","completed","archived"]
			}

			this.getJSON(this.apiResource + "/get",params).then(response => {
				vm.jobsLoading = false
				if (response.success) {

					vm.$nextTick(() => {
						vm.jobs = response.data

						if (vm.hideArchived)
							vm.jobs = vm.jobs.filter(job => job.archived == 0)

						if (vm.hideCompleted && vm.jobType == 'service') 
							vm.jobs = vm.jobs.filter(job => !job.completed)

						vm.$forceUpdate()

					})
				}
			})
		}
	},
	created() {
		let vm = this

		if (!this.value || this.value == 0) 
			this.fetchFirstPageJobs()

		this.setLocalValue()
	}
}
</script>